<script setup lang="ts">import { computed as _computed } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
defineProps({
  value: null
});
defineEmits(["input"]);
import i18n from '@/i18n';

const innerIcon = _computed(() => 'icon-clock');

const historyDaysList = [
  { value: 7, text: `7 ${i18n.t('dashboard.days')}` },
  { value: 14, text: `14 ${i18n.t('dashboard.days')}` },
  { value: 30, text: `30 ${i18n.t('dashboard.days')}` },
  { value: 90, text: `90 ${i18n.t('dashboard.days')}` },
];

const { value: historyDays } = __MACROS_useVModel(["value", undefined, "input"]);
</script>

<template lang="pug">
v-select(
  v-model="historyDays"
  :items="historyDaysList"
  :prepend-inner-icon="innerIcon"
  :menu-props="{ bottom: true, offsetY: true }"
  class="days-selector"
  dense
  outlined
  hide-details
)
</template>

<style scoped>
.days-selector {
  width: 140px;
}

/* To remove the input component that is automatically added by v-select and that we don't need */
.days-selector::v-deep.v-input input {
  display: none;
}
</style>
